module.exports = __webpack_public_path__ + "media/images/global/icons/petit-gift-af91067993462fa9bc7f986a0a1ec047.svg";